import { type ApiPaymentInfo } from '@Model';
import {
    Checkbox,
    Grid,
    GridColumns,
    ISubFrameBodyProps,
    LabeledDiv,
    TextInput,
    useGuiBinder,
    useTranslate,
} from '@synqo/frontend-component-library';
import { formatIban } from '../../../formatters';

export function FrameEditPaymentInfo(props: ISubFrameBodyProps<ApiPaymentInfo>) {
    const i18n = useTranslate('');

    const binder = useGuiBinder<ApiPaymentInfo>(props);

    return (
        <Grid columns={14}>
            <GridColumns spans={[3, 3, 3, 3, 2]}>
                <TextInput {...binder.bindToProp('account_holder')} label={i18n('Kontoinhaber')} />
                <TextInput {...binder.bindToProp('iban', undefined, formatIban)} label="IBAN" />
                <TextInput {...binder.bindToProp('bic')} label="BIC" />
                <TextInput {...binder.bindToProp('bank')} label={i18n('Kreditinstitut')} />
                <LabeledDiv label="&nbsp;" htmlFor="">
                    <Checkbox {...binder.bindToAutoConfirmed('is_default')} label="Standard" />
                </LabeledDiv>
            </GridColumns>
        </Grid>
    );
}
